import { 
    Grid, 
    Text
} from "@nextui-org/react"
import { useNavigate } from "react-router-dom"

import ScreenWidthDependent from "../../ui/layout/screenWidthDependent"
import HowItWorksImg from '../../ui/resources/GL_how_it_works.png'
import SectionBkg from '../../ui/resources/GL_section_bkg_1.png'
import { Box } from "../../ui/layout/box"
import { Content } from "../../ui/layout/content"
import Header from "../../ui/header"
import Button from "../../ui/button"
import './index.css'

export default ({}) => {
    const navigate = useNavigate()

    return (
        <>
            {/* <img 
                src={SectionBkg}
                style={{
                    position: "absolute",
                    width: "100%",
                    height: "50%",
                    zIndex: -1,
                    // transform: "scaleX(-1)"
                }} /> */}
            <Content spacerSize={4} id="how-it-works">
                <Header value="How It Works" h1 centered />
                <Text size="$sm" className="font-text" css={{mt: "$md", ta: "center"}}>We do the heavy lifting</Text>
            </Content>
            <ScreenWidthDependent showInDesktopOnly={true}>
                <Box css={{display: "flex", flexDirection: "column", alignItems: "center"}}>
                    <Box css={{
                        '@smMin': {
                            width: "90%"
                        },
                        '@mdMin': {
                            width: "85%"
                        },
                        '@lgMin': {
                            // width: "65%"
                        }
                    }}>
                        <img src={HowItWorksImg}/>
                    </Box>
                    <Box>
                        <Button 
                            text="Browse Opportunities"
                            onClick={() => navigate('/opportunities')}/>
                    </Box>
                </Box>
            </ScreenWidthDependent>
            <ScreenWidthDependent showInMobileOnly={true} mt="50px">
                <Grid.Container gap={2}>
                    <Grid xs={12} css={{flexDirection: "column"}}>
                        <div className="GL_how_it_works_step">01</div>
                        <Header value="Browse Opportunities" h2/>
                        <Text size="$sm">Browse grants offered by government, and universities as well as collaboration opportunities with researchers.</Text>
                    </Grid>
                    <Grid xs={12} css={{flexDirection: "column"}}>
                        <div className="GL_how_it_works_step">02</div>
                        <Header value="Let Us Know" h2/>
                        <Text size="$sm">Decide which opportunity you are most interested in and let us know by submitting an online application form.</Text>
                    </Grid>
                    <Grid xs={12} css={{flexDirection: "column"}}>
                        <div className="GL_how_it_works_step">03</div>
                        <Header value="Review" h2/>
                        <Text size="$sm">We will review and assess your application to identify the most suitable academic partner for you.</Text>
                    </Grid>
                    <Grid xs={12} css={{flexDirection: "column"}}>
                        <div className="GL_how_it_works_step">04</div>
                        <Header value="Connect" h2/>
                        <Text size="$sm">We will reach out to you to arrange an initial meeting to connect you with our academic partner.</Text>
                    </Grid>
                    <Grid xs={12} css={{flexDirection: "column"}}>
                        <div className="GL_how_it_works_step">05</div>
                        <Header value="Grant Applications" h2/>
                        <Text size="$sm">We will work with you and the academic partner to prepare materials required for grant application or formal collaboration.</Text>
                    </Grid>
                    <Grid xs={12} justify="center">
                        <Box css={{mt: "50px"}}>
                            <Button 
                                text="Browse Opportunities"
                                onClick={() => navigate('/opportunities')}/>
                        </Box>
                    </Grid>
                </Grid.Container>
            </ScreenWidthDependent>
        </>
    )
}